// extracted by mini-css-extract-plugin
export default {"tabbedBrandsMobileMenuTabs":"TabbedBrandsMobileMenuTabs-tabbedBrandsMobileMenuTabs--a7e22","activeTab":"TabbedBrandsMobileMenuTabs-activeTab--7415c"};